<script setup lang="ts">
    import { ChevronDownIcon } from '@lucide/vue';
    import { useSlots } from 'vue';

    const slots = useSlots();
</script>

<template>
    <details class="Accordion group rounded-md overflow-hidden text-body">
        <summary
            class="appearance-none cursor-pointer relative flex items-center px-5 py-2.5 text-body-bold custom-focus rounded-md"
        >
            <template v-if="slots.summaryOpen">
                <div class="hidden group-open:block">
                    <slot name="summaryOpen" />
                </div>
                <div class="block group-open:hidden">
                    <slot name="summary" />
                </div>
            </template>
            <template v-else>
                <slot name="summary" />
            </template>
            <ChevronDownIcon class="size-5" />
        </summary>

        <slot />
    </details>
</template>
